import { render, staticRenderFns } from "./ProfileQuestionnaire.vue?vue&type=template&id=3210e3ca&"
import script from "./ProfileQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./ProfileQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports